import { myGet, handleGetError } from '../utils/myAxios'
import { servAddr } from '../servAddr'

export function fetchPayments() {
  return dispatch => {
    myGet(dispatch, servAddr + 'rep_payments').then((response) => {
      dispatch({type: "FETCH_PAYMENTS", payments: response.data});
    }, (err) => {
      handleGetError(dispatch, err);
    })
  }
}

export function fetchIncome(from="", to="") {
  return dispatch => {
    myGet(dispatch, servAddr + 'rep_income', {params: {from, to}}).then((response) => {
      dispatch({type: "FETCH_INCOME", payload: response.data});
    }, (err) => {
      handleGetError(dispatch, err);
    })
  }
}

export function fetchAbc(params) {
  return dispatch => {
    myGet(dispatch, servAddr + 'rep_abc', {params}).then((response) => {
      dispatch({type: "FETCH_ABC", payload: response.data});
    }, (err) => {
      handleGetError(dispatch, err);
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/reportActions.js